import { Component } from '@angular/core';
import pkg from '../../../package.json' with { type: 'json' };

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  protected currentYear: number;
  protected version = pkg.version ?? '0.0.0';

  constructor() {
    this.currentYear = new Date().getFullYear();
  }
}
